import request from '../utils/request'
import { ParamsProps, ReturnType } from './types'

const login = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/login`,
      method: 'post',
      authorization: false,
      data: args?.data,
      config: {
        showErr: true,
        successMsg: 'Login Successfully',
        store: {
          action: 'set',
          key: 'user',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const logout = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/logout`,
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        successMsg: 'Logout Successfully',
        store: {
          action: 'reset',
          key: 'user',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const register = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/register`,
      method: 'post',
      authorization: false,
      data: args?.data,
      config: {
        showErr: true,
        successMsg: 'Registered successfully',
        store: {
          action: 'set',
          key: 'user',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users`,
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        successMsg: 'Registered successfully',
        store: {
          action: args?.action,
          key: args?.state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        successMsg: 'Update successfully',
        store: {
          action: 'update',
          key: args?.state || 'user',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err) {
    throw new Error(err)
  }
}

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: args?.state || 'user',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const get = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: args?.state,
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users`,
      method: 'get',
      params: args?.params,
      authorization: false,
      config: {
        showErr: true,
        store: {
          action: args?.action || 'set',
          key: args?.state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err) {
    throw new Error(err)
  }
}

const updateStatus = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/status/${args?.id}`,
      method: 'patch',
      data: args?.data,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: args?.action,
          key: args?.state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err) {
    throw new Error(err)
  }
}

const changePassword = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/change-password`,
      method: 'patch',
      data: args?.data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Password change successful!',
        store: {
          action: 'update',
          key: 'user',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err) {
    throw new Error(err)
  }
}

const linkBankAccount = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/link-account`,
      method: 'post',
      data: args?.data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Account Linked Successfully',
        store: {
          action: 'update',
          key: 'user',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const queue = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/queue`,
      method: 'post',
      data: args?.data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Queue Created Successfully',
        store: {
          action: 'update',
          key: 'user',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const patients = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/patients`,
      method: 'get',
      params: args?.params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: args?.action,
          key: 'patients',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const appointments = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/${args?.id}/appointments`,
      method: 'get',
      params: args?.params || {},
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: 'userAppointment',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default {
  login,
  logout,
  create,
  update,
  register,
  find,
  get,
  list,
  updateStatus,
  changePassword,
  linkBankAccount,
  queue,
  patients,
  appointments,
}
